var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-avatar",class:{ 'person-avatar--white': _vm.white }},[_c('img',{attrs:{"src":require("@/assets/img/user@2x.png"),"alt":"Avatar","width":"16","height":"16"}})])}
var staticRenderFns = []

export { render, staticRenderFns }